import { useTranslation } from "react-i18next";

const TinkoffLogo = ({height}) => {
    const { t } = useTranslation();
    return (
    <div 
        className="flex gap-2 items-center w-fit" 
        style={{
            height: height,
        }}
    >
        <div 
            style={{
                height: height,
                position: "relative",
                width: height,
            }}
        >
            <img
                src="/static/images/png/tinkoff_logo.png" 
                alt="Moka Pos Logo"
                style={{
                    height: "100%",
                    width: "100%",
                    position:"absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    margin: "auto",
                }}                
            />
        </div>
        <span className="font-medium text-2xs sm:text-sm">
            {t("bills.bill_info.roubles")}
        </span>
    </div>
  )
}

export default TinkoffLogo